import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

/**
 * Teslim bilgisi iptal onay modalı
 * @param {Object} props - Komponent props'ları
 * @returns {JSX.Element} Onay modalı
 */
const ConfirmationModal = ({
    isOpen,              // Modal'ın açık/kapalı durumu
    toggle,              // Modal'ı açıp/kapatan fonksiyon
    title,              // Modal başlığı
    message,            // Modal mesajı
    onConfirm,          // Onay butonuna tıklandığında çalışacak fonksiyon
    isProcessing,       // İşlem devam ediyor mu?
    confirmText = "Onayla",  // Onay butonu metni
    cancelText = "İptal"     // İptal butonu metni
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="md" centered>
            <ModalHeader toggle={toggle} className="border-0 pb-0">
                <h4 className="mb-0 fw-semibold">{title}</h4>
            </ModalHeader>

            <ModalBody className="px-4">
                <div className="alert alert-dark d-flex align-items-center" role="alert">
                    <i className="fa fa-info-circle me-2"></i>
                    {message}
                </div>

                <div className="mt-4 text-center">
                    <h5 className="mb-0 fw-medium" style={{ fontSize: '1.2rem', color: '#333' }}>
                        Bu işlemi gerçekleştirmek istediğinize emin misiniz?
                    </h5>
                </div>
            </ModalBody>

            <ModalFooter className="px-4">
                <button
                    className="btn btn-light px-4"
                    onClick={toggle}
                    disabled={isProcessing}
                >
                    {cancelText}
                </button>
                <button
                    className="btn btn-dark px-4"
                    onClick={onConfirm}
                    disabled={isProcessing}
                >
                    {isProcessing && <i className="fa fa-spinner fa-spin me-2"></i>}
                    {confirmText}
                </button>
            </ModalFooter>

            <style jsx>{`
                :global(.modal-content) {
                    border: none;
                    border-radius: 8px;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
                }

                :global(.alert) {
                    background-color: #e8f4fd;
                    border: none;
                    border-radius: 6px;
                    color: #0a558c;
                    font-size: 0.95rem;
                    line-height: 1.5;
                }

                :global(.alert i) {
                    color: #0a558c;
                    font-size: 1.1rem;
                }

                :global(.btn) {
                    padding: 0.625rem 1.25rem;
                    font-weight: 500;
                    font-size: 0.95rem;
                    border-radius: 6px;
                }

                :global(.btn-light) {
                    background: #f8f9fa;
                    border: 1px solid #dee2e6;
                }

                :global(.btn-light:hover) {
                    background: #e9ecef;
                }

                :global(.btn-dark) {
                    background: #212529;
                    border: 1px solid #212529;
                }

                :global(.btn-dark:hover) {
                    background: #000;
                }

                :global(.btn-dark:disabled) {
                    background: #495057;
                    border-color: #495057;
                }
            `}</style>
        </Modal>
    );
};

// Prop tipleri tanımlaması
ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string
};

export default ConfirmationModal; 